export enum EClearCookieFormFields {
  clearButtonLabel = 'clearButtonLabel',
  noCookieText = 'noCookieText',
  cookieText = 'cookieText',
  afterClearMessage = 'afterClearMessage'
}
